import type React from "react";
import type { Comment } from "@/types/channel/comment";
import { CommentItem } from "../CommentItem/CommentItem";

interface CommentListProps {
	comments: Comment[];
}

export const CommentList: React.FC<CommentListProps> = ({ comments }) => {
	return (
		<div className="space-y-4">
			{comments.length === 0 ? (
				<p className="text-center text-gray-500 py-2">
					まだコメントがありません。最初のコメントを投稿しましょう！
				</p>
			) : (
				comments.map((comment) => (
					<CommentItem key={comment.id} comment={comment} />
				))
			)}
		</div>
	);
};
